import { formatLongDate } from '@backrs_ui/common-ui/src/utils/dateTime.util';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  DailyQuestion,
  TestDate,
} from '@backrs_ui/grow-ui/src/redux/satActBooster/satActBooster.types';

const SKILL_STRINGS = appStrings.modules.satActBooster.dailyPractice.skill;

/**
 * Skill label the by-skill breakdown groups a question under: the strand's own name when the
 * question carries one, a numbered stand-in when it is tagged but unnamed, and a catch-all
 * otherwise.
 */
export const skillLabelFor = (question: Pick<DailyQuestion, 'strandId' | 'strandName'>): string => {
  if (question.strandName) return question.strandName;
  if (question.strandId != null) return SKILL_STRINGS.strand(question.strandId);

  return SKILL_STRINGS.general;
};

/** An ISO date as "Aug 12, 2026", falling back to the raw value when it won't parse. */
export const longDate = (isoDate: string): string => {
  try {
    return formatLongDate(isoDate);
  } catch {
    return isoDate;
  }
};

export const testDateLabel = (testDate: Pick<TestDate, 'date'>): string => longDate(testDate.date);

/** English ordinal suffix for a whole number (1 → "1st", 83 → "83rd"). */
export const ordinal = (value: number): string => {
  const mod100 = value % 100;
  const mod10 = value % 10;

  if (mod100 >= 11 && mod100 <= 13) return `${value}th`;
  if (mod10 === 1) return `${value}st`;
  if (mod10 === 2) return `${value}nd`;
  if (mod10 === 3) return `${value}rd`;

  return `${value}th`;
};
